import {
  SET_ALL_STORE_LOCATIONS,
  ALL_STORE_LOCATIONS_ERROR,
} from "../actions/store-locations";

const initialState = {
  error: null,
  stores: [],
  lastUpdated: null,
};

const storeLocations = (state = initialState, action) => {
  switch (action.type) {
    case SET_ALL_STORE_LOCATIONS:
      return {
        ...state,
        stores: action.payload.data.stores,
        lastUpdated: action.payload.receivedAt,
      };
    case ALL_STORE_LOCATIONS_ERROR:
      return {
        ...state,
        error: action.payload.error.toString(),
      };
  }

  return state;
};

export default storeLocations;
